<template>
  <div
    class="Re_form_group"
    :class="{ 'error': hasErrors }"
    :data-name="dataName"
  >
    <div class="Form_groupPhoneNumber">
      <label class="Re_form_label" v-if="label" :class="{'form_label': top}">{{ label }}</label>
      <input
        class="Re_form_control"
        :class="{'form_control': top}"
        :placeholder="top ? null : placeholder"
        :value="value"
        :text="text"
        v-bind="$attrs"
        v-on="listeners"
        @change.native="change"
        :autocomplete="autocomplete"
        :type="$attrs.type || 'tel'"
      >
      <v-popover
        offset="5"
        trigger="manual"
        placement="bottom-end"
        :open="isOpen"
        :class="[{'phoneNumber-help': top}, {'phoneNumber-help2': (errors.length>0 || triggerChange)} ]"
      >
        <span @click="openTooltip">
          <app-icon name="help-circle" />
        </span>
        <template slot="popover">
          <div v-click-outside="closeTooltip">{{ $t('common.tooltip.phoneNumber', 'It may occur that we contact you in case of any issues during the delivery process') }}</div>
        </template>
      </v-popover>

    </div>
    <p class="tip-error" v-for="(error, index) in errors" :key="index">{{ text || label || placeholder }} {{ error }}</p>
    <p class="tip-error" v-if="triggerChange">{{ tips }}</p>
  </div>
</template>

<script>
  import InputMixin from './input'
  import ValidationMixin from './validation'

  export default {
    mixins: [InputMixin, ValidationMixin],

    data () {
      return {
        isOpen: false,
        isOpenTooltip: false
      }
    },

    methods: {
      change () {
        if (this.triggerChange) {
          this.$emit('change')
        }
      },
      openTooltip () {
        this.isOpen = !this.isOpen
        this.isOpenTooltip = true
      },
      closeTooltip () {
        if (!this.isOpenTooltip) {
          this.isOpen = false
          this.isOpenTooltip = false
        }
      }
    }
  }
</script>

<style lang="scss">
  .phoneNumber-help {
    display: flex;
    position: absolute;
    right: .15rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    .icon-help-circle {
      color: #4a4a4a;
      opacity: 0.245;
    }
  }

  .PersoanlDetail_body {
    .v-popover {
      top: 29%;
      right: 0%;
      position: absolute;
    }

    span {
      position: absolute;
      right: 0.15rem;
      top: 0;
      display: flex;
    }
  }

  .phoneNumber-help2 {
    display: flex;
    position: absolute;
    right: .15rem;
    top: 20%;
    transform: translateY(-50%);
    cursor: pointer;

    .icon-help-circle {
      color: #4a4a4a;
      opacity: 0.245;
    }
  }

  .phone-number-info {
    display: flex;
  }

  .tooltip {
    display: block;
    z-index: 99;
    background: #fff;
    outline: 0;

    a {
      color: #0066a1;
    }

    &.popover {
      $color: #d6d6d6;

      .popover-inner {
        border-style: solid;
        border-width: .01rem;
        border-color: $color;
        border-radius: .02rem;
        padding: .23rem .16rem;
        box-shadow: 0 2px 4px $color;
        max-width: 226px;
        font-size: .14rem;
        line-height: .19rem;
      }

      .popover-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: $color;
        z-index: 1;
      }

      &[x-placement^="top"] {
        margin-bottom: 5px;

        .tooltip-arrow {
          border-width: .09rem;
          border-bottom-width: 0;
          border-left-color: transparent !important;
          border-right-color: transparent !important;
          border-bottom-color: transparent !important;
          bottom: -9px;
          left: calc(50% - 9px);
          margin-top: 0;
          margin-bottom: 0;

          &::before {
            content: "";
            position: absolute;
            border-style: solid;
            border-width: .09rem;
            border-bottom-width: 0;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            border-top: 9px solid #fff;
            bottom: 1px;
            left: calc(50% - 9px);
          }
        }
      }

      &[x-placement^="bottom"] {
        margin-top: 5px;

        .tooltip-arrow {
          border-width: .09rem;
          border-top-width: 0;
          border-left-color: transparent !important;
          border-right-color: transparent !important;
          border-top-color: transparent !important;
          top: -9px;
          left: calc(50% - 9px);
          margin-top: 0;
          margin-bottom: 0;

          &::before {
            content: "";
            position: absolute;
            border-style: solid;
            border-width: .09rem;
            border-top-width: 0;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-top-color: transparent !important;
            border-bottom: 9px solid #fff;
            top: 1px;
            left: calc(50% - 9px);
          }
        }
      }
    }
  }
</style>
